export default {
  suppliers: [],
  supplier: undefined,
  search: '',
};
